export default __webpack_public_path__ + "static/media/PSO 06 - Protocolo de Verificação e Aplicação de Lacres (Rev. 01 - 21.11.2025).c03d3593.pdf";